import { z } from 'zod';

export const fileFolderSchema = z.object({
  id: z.string(),
  name: z.string(),
  agencyId: z.string(),
  clientId: z.string().nullable(),
  parentId: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type FileFolderSchema = z.infer<typeof fileFolderSchema>;

/** A folder plus its ancestors (root-first), used to render breadcrumbs. */
export const fileFolderWithPathSchema = fileFolderSchema.extend({
  path: z.array(z.object({ id: z.string(), name: z.string() })),
});

export type FileFolderWithPathSchema = z.infer<typeof fileFolderWithPathSchema>;
